export const raffle = {
  raffleTitle: "抽奖",
  raffleBtnMyTickets: "我的票",
  rafflePrize: "奖品",
  raffleBtnBuy: "买票",
  raffleStatus: "即时",
  raffleModalTitle: "买票 ",
  raffleModalPrice: "票价",
  raffleModalTotalPrice: "总价",
  raffleModalQuantity: "请输入数量",
  raffleModalBtnBuy: "买票",
  raffleModalBuyQuantity: "购买多少张票?",
  raffleModalChooseNumber: "选择数字",
  raffleModalChooseRandom: "随机数",
  raffleModalBackBtn: "返回",
  raffleTicketPurchase: "购买成功!",
  raffleTicketCreatedMessage: "请输入有效的数字作为每张票的数量。",
  raffleTicketPurchaseError: "购买票失败,请稍后再试。",
  raffleErrorMessage: "购买票失败",
};
